import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { findActiveCatalogProduct } from '@pedix-workspace/api-v1';
import { AppRequestContextService } from '../../../app-request-context.service';

export const productExistsGuardFn: CanActivateFn = (routeSnapshot: ActivatedRouteSnapshot) => {
  const appRequestContext = inject(AppRequestContextService);
  const router = inject(Router);

  const { productId, categoryId } = routeSnapshot.params;

  const product = findActiveCatalogProduct(appRequestContext.catalog(), {
    productIdOrSlug: productId,
    categoryIdOrSlug: categoryId,
  });

  if (!product) {
    return router.createUrlTree(['/']);
  }

  // NOTE: If matches deprecated route 'producto/:productId', then redirects to 'categoria/:categoryId/producto/:productId'
  if (routeSnapshot.routeConfig.path === 'producto/:productId') {
    return router.createUrlTree([`/categoria/${product.categoryId}/producto/${product.id}`]);
  }
  return true;
};
